import React, { useState } from 'react';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import FormLabel from '../common/form/FormLabel';
import 'dayjs/locale/ko'; 
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid'; 
import { createDraggablePaperComponent } from '../common/dialog/DraggablePaper';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'; 
import DateAdapter from '@mui/lab/AdapterDateFns';
import * as dayjs from 'dayjs'



import BootstrapDialog, {
  BootstrapDialogTitle,
} from '../common/dialog/BootstrapDialog';
import { useRef } from 'react';

const PaperComponent = createDraggablePaperComponent('draggable-emp-dialog');

const OrderSheetEditModal = ({ open, handleClose, onSave, currentData }) => {
  const dateFocus = useRef();

  const [sheetCrtDate, setSheetCrtDate] = useState(
    currentData?.sheetCrtDate || new Date(),
  );

  const handleSave = () => {
    if (sheetCrtDate === null || sheetCrtDate === '') {
      alert('발주일자를 입력하세요');
      dateFocus.current.focus();
      return;
    }

    onSave(sheetCrtDate);
    handleClose();
  };

  if (!currentData) {
    return null;
  }

  return (
    <BootstrapDialog
      open={open}
      onClose={handleClose}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-emp-dialog"
      fullWidth={true}
      maxWidth="sm"
    >
      <BootstrapDialogTitle
        style={{ cursor: 'move' }}
        id="draggable-emp-dialog"
        onClose={handleClose}
      >
        {currentData?.cstNm} 수정
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
          sx={{
            py: 1,
          }}
        >
          <Grid item xs={4}>
            <FormLabel>
              발주일자
              <Typography
                variant="subtitle2"
                component="span"
                sx={{ mx: 1, color: 'error.main' }}
              >
                (필수)
              </Typography>
            </FormLabel>
          </Grid>
          <Grid item xs={8}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
              <DatePicker
                format="YYYY-MM-DD"
                mask={'____-__-__'}
                id="sheetCrtDate"
                name="sheetCrtDate"
                value={dayjs(sheetCrtDate)}
                onChange={(newValue) => {
                  setSheetCrtDate(dayjs(newValue));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    sx={{ width: 180 }}
                    variant="outlined"
                    size="small"
                    required={true}
                    fullWidth
                  />
                )}
              />
            </LocalizationProvider>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'space-between' }}>
        <Button variant="outlined" color="inherit" onClick={handleClose}>
          취소
        </Button>
        <Button variant="contained" onClick={handleSave}>
          저장
        </Button>
      </DialogActions>
    </BootstrapDialog>
  );
};

export default OrderSheetEditModal;
